document.addEventListener('DOMContentLoaded', function() {
  // Find all modals and move them to the end of the body
  const foxIntolModals = document.querySelectorAll('[data-fox-intol-modal]');
  foxIntolModals.forEach(modal => {
    // Clone the modal and its contents
    const modalClone = modal.cloneNode(true);
    
    // Remove the original modal
    modal.parentNode.removeChild(modal);
    
    // Append the cloned modal to the body
    document.body.appendChild(modalClone);
    
    // Store the original modal ID in a data attribute for reference
    if (modal.id) {
      modalClone.setAttribute('data-original-id', modal.id);
    }
  });
  
  // Find all modal triggers
  const modalTriggers = document.querySelectorAll('[data-modal-open]');
  
  // Apply force CSS class to all modals to ensure visibility
  document.querySelectorAll('[data-fox-intol-modal]').forEach(modal => {
    if (!modal.classList.contains('fox-intol-modal-styled')) {
      modal.classList.add('fox-intol-modal-styled');
    }
    // Remove any potentially conflicting classes
    if (modal.classList.contains('xbg')) {
      modal.classList.remove('xbg');
    }
    if (modal.classList.contains('modal')) {
      modal.classList.remove('modal');
    }
  });
  
  // Add click event listener to each trigger
  modalTriggers.forEach((trigger, index) => {
    const targetModal = trigger.getAttribute('data-modal-open');
    
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      
      const modalId = this.getAttribute('data-modal-open');
      const modal = document.querySelector(modalId);
      
      if (modal) {
        // Remove any conflicting classes
        if (modal.classList.contains('xbg')) {
          modal.classList.remove('xbg');
        }
        if (modal.classList.contains('modal')) {
          modal.classList.remove('modal');
        }
        
        // Add our classes and force styling
        modal.classList.add('is-active', 'fox-intol-modal-styled');
        modal.setAttribute('aria-hidden', 'false');
        
        // Force inline styles to ensure visibility
        modal.style.display = 'block';
        modal.style.zIndex = '9999';
        modal.style.position = 'fixed';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        
        // Apply styles to overlay and content
        const overlay = modal.querySelector('.fox-intol-modal__overlay');
        if (overlay) {
          overlay.style.position = 'fixed';
          overlay.style.top = '0';
          overlay.style.left = '0';
          overlay.style.right = '0';
          overlay.style.bottom = '0';
          overlay.style.display = 'flex';
          overlay.style.justifyContent = 'center';
          overlay.style.alignItems = 'center';
          overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        }
        
        const content = modal.querySelector('.fox-intol-modal__content');
        if (content) {
          content.style.backgroundColor = '#fff';
          content.style.padding = '30px';
          content.style.maxWidth = '500px';
          content.style.width = '90%';
          content.style.maxHeight = '90vh';
          content.style.overflowY = 'auto';
          content.style.position = 'relative';
          content.style.borderRadius = '4px';
          content.style.margin = '20px';
          content.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
          
          // Prevent clicks on the content from closing the modal
          content.addEventListener('click', function(event) {
            event.stopPropagation();
          });
          
          // Add specific event stopping for videos and iframes
          const videoElements = content.querySelectorAll('video, iframe');
          videoElements.forEach(video => {
            video.addEventListener('click', function(event) {
              event.stopPropagation();
            });
            
            // For touch devices
            video.addEventListener('touchstart', function(event) {
              event.stopPropagation();
            });
            
            // Specifically for play/pause events
            if (video.tagName === 'VIDEO') {
              video.addEventListener('play', function(event) {
                event.stopPropagation();
              });
              
              video.addEventListener('pause', function(event) {
                event.stopPropagation();
              });
            }
          });
          
          // Also prevent the video container from propagating events
          const videoContainers = content.querySelectorAll('.video-container, .fox-intol-modal__media');
          videoContainers.forEach(container => {
            container.addEventListener('click', function(event) {
              event.stopPropagation();
            });
            
            container.addEventListener('touchstart', function(event) {
              event.stopPropagation();
            });
          });
        }
        
        // Function to stop video playback in a modal
        const stopVideoPlayback = function(modal) {
          // Handle HTML5 video elements
          const videoElements = modal.querySelectorAll('video');
          if (videoElements.length > 0) {
            videoElements.forEach(video => {
              if (typeof video.pause === 'function') {
                video.pause();
                // Reset video to beginning if desired
                if (video.currentTime) {
                  video.currentTime = 0;
                }
              }
            });
          }
          
          // Handle YouTube/Vimeo iframes
          const iframes = modal.querySelectorAll('iframe');
          if (iframes.length > 0) {
            iframes.forEach(iframe => {
              // Store the current src
              const src = iframe.src;
              
              // Setting src to empty and then back effectively stops playback
              iframe.src = '';
              
              // Need a slight delay before setting it back
              setTimeout(() => {
                iframe.src = src;
              }, 10);
            });
          }
        };

        // Close when clicking overlay or close button
        const closeElements = modal.querySelectorAll('[data-modal-close]');
        
        closeElements.forEach(el => {
          el.addEventListener('click', function(event) {
            event.stopPropagation(); // Prevent event bubbling
            // Stop video playback before hiding the modal
            stopVideoPlayback(modal);
            modal.classList.remove('is-active');
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
          });
        });
        
        // Close on escape key
        const escapeHandler = function(e) {
          if (e.key === 'Escape' && modal.classList.contains('is-active')) {
            // Stop video playback before hiding the modal
            stopVideoPlayback(modal);
            modal.classList.remove('is-active');
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
            // Remove this specific escape handler when modal is closed
            document.removeEventListener('keydown', escapeHandler);
          }
        };
        
        document.addEventListener('keydown', escapeHandler);
      }
    });
  });
});

// Fallback initialization in case DOMContentLoaded already fired
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(() => {
    // Move all modals to the end of the body
    const foxIntolModals = document.querySelectorAll('[data-fox-intol-modal]');
    foxIntolModals.forEach(modal => {
      // Clone the modal and its contents
      const modalClone = modal.cloneNode(true);
      
      // Remove the original modal
      modal.parentNode.removeChild(modal);
      
      // Append the cloned modal to the body
      document.body.appendChild(modalClone);
      
      // Store the original modal ID in a data attribute for reference
      if (modal.id) {
        modalClone.setAttribute('data-original-id', modal.id);
      }
    });
    
    const modalTriggers = document.querySelectorAll('[data-modal-open]');
    
    if (modalTriggers.length > 0) {
      // Apply force CSS class to all modals to ensure visibility
      document.querySelectorAll('[data-fox-intol-modal]').forEach(modal => {
        if (!modal.classList.contains('fox-intol-modal-styled')) {
          modal.classList.add('fox-intol-modal-styled');
        }
        // Remove any potentially conflicting classes
        if (modal.classList.contains('xbg')) {
          modal.classList.remove('xbg');
        }
        if (modal.classList.contains('modal')) {
          modal.classList.remove('modal');
        }
      });
      
      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(event) {
          event.preventDefault();
          
          const modalId = this.getAttribute('data-modal-open');
          const modal = document.querySelector(modalId);
          
          if (modal) {
            // Remove any conflicting classes
            if (modal.classList.contains('xbg')) {
              modal.classList.remove('xbg');
            }
            if (modal.classList.contains('modal')) {
              modal.classList.remove('modal');
            }
            
            // Add our classes and force styling
            modal.classList.add('is-active', 'fox-intol-modal-styled');
            modal.setAttribute('aria-hidden', 'false');
            
            // Force inline styles to ensure visibility
            modal.style.display = 'block';
            modal.style.zIndex = '9999';
            modal.style.position = 'fixed';
            modal.style.top = '0';
            modal.style.left = '0';
            modal.style.width = '100%';
            modal.style.height = '100%';
            
            // Apply styles to overlay and content
            const overlay = modal.querySelector('.fox-intol-modal__overlay');
            if (overlay) {
              overlay.style.position = 'fixed';
              overlay.style.top = '0';
              overlay.style.left = '0';
              overlay.style.right = '0';
              overlay.style.bottom = '0';
              overlay.style.display = 'flex';
              overlay.style.justifyContent = 'center';
              overlay.style.alignItems = 'center';
              overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
            }
            
            const content = modal.querySelector('.fox-intol-modal__content');
            if (content) {
              content.style.backgroundColor = '#fff';
              content.style.padding = '30px';
              content.style.maxWidth = '500px';
              content.style.width = '90%';
              content.style.maxHeight = '90vh';
              content.style.overflowY = 'auto';
              content.style.position = 'relative';
              content.style.borderRadius = '4px';
              content.style.margin = '20px';
              content.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
              
              // Prevent clicks on the content from closing the modal
              content.addEventListener('click', function(event) {
                event.stopPropagation();
              });
              
              // Add specific event stopping for videos and iframes
              const videoElements = content.querySelectorAll('video, iframe');
              videoElements.forEach(video => {
                video.addEventListener('click', function(event) {
                  event.stopPropagation();
                });
                
                // For touch devices
                video.addEventListener('touchstart', function(event) {
                  event.stopPropagation();
                });
                
                // Specifically for play/pause events
                if (video.tagName === 'VIDEO') {
                  video.addEventListener('play', function(event) {
                    event.stopPropagation();
                  });
                  
                  video.addEventListener('pause', function(event) {
                    event.stopPropagation();
                  });
                }
              });
              
              // Also prevent the video container from propagating events
              const videoContainers = content.querySelectorAll('.video-container, .fox-intol-modal__media');
              videoContainers.forEach(container => {
                container.addEventListener('click', function(event) {
                  event.stopPropagation();
                });
                
                container.addEventListener('touchstart', function(event) {
                  event.stopPropagation();
                });
              });
            }
            
            // Function to stop video playback in a modal
            const stopVideoPlayback = function(modal) {
              // Handle HTML5 video elements
              const videoElements = modal.querySelectorAll('video');
              if (videoElements.length > 0) {
                videoElements.forEach(video => {
                  if (typeof video.pause === 'function') {
                    video.pause();
                    // Reset video to beginning if desired
                    if (video.currentTime) {
                      video.currentTime = 0;
                    }
                  }
                });
              }
              
              // Handle YouTube/Vimeo iframes
              const iframes = modal.querySelectorAll('iframe');
              if (iframes.length > 0) {
                iframes.forEach(iframe => {
                  // Store the current src
                  const src = iframe.src;
                  
                  // Setting src to empty and then back effectively stops playback
                  iframe.src = '';
                  
                  // Need a slight delay before setting it back
                  setTimeout(() => {
                    iframe.src = src;
                  }, 10);
                });
              }
            };

            // Set up close handlers
            const closeElements = modal.querySelectorAll('[data-modal-close]');
            closeElements.forEach(el => {
              el.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent event bubbling
                // Stop video playback before hiding the modal
                stopVideoPlayback(modal);
                modal.classList.remove('is-active');
                modal.style.display = 'none';
                modal.setAttribute('aria-hidden', 'true');
              });
            });
            
            // Setup escape key handling
            document.addEventListener('keydown', function(e) {
              if (e.key === 'Escape' && modal.classList.contains('is-active')) {
                // Stop video playback before hiding the modal
                stopVideoPlayback(modal);
                modal.classList.remove('is-active');
                modal.style.display = 'none';
                modal.setAttribute('aria-hidden', 'true');
              }
            });
          }
        });
      });
    }
  }, 100);
} 